import Vue from 'vue'
import App from './App.vue'
import './lib/prototypes'
//import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import TextAssetMixin from './mixins/textassets';
import {i18n} from './plugins/i18n'
import ApplicationEventHub from "./events/applicationEventHub";
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

Vue.config.productionTip = false;

Vue.mixin(TextAssetMixin);
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
  mounted(){
    this.listenForLanguageChanges();
  },
  methods:{
    listenForLanguageChanges(){
      ApplicationEventHub.$on('language.change',(langCode)=>{
        this.$vuetify.lang.current = langCode;
        this.$i18n.locale = langCode;
        this.$vuetify.rtl = langCode==='ar';
        document.querySelector('html').setAttribute('lang', langCode);
      });
    }
  }
}).$mount('#app');


import './http/axiosInit'
import './lib/demoShow'

if(process.env.VUE_APP_LOG_ERRORS==1){
  Sentry.init({
    dsn: 'https://4de19cf00319431e9403a1a09cc463a1@o103978.ingest.sentry.io/5271766',
    integrations: [new VueIntegration({Vue, attachProps: true, logErrors:true})],
  });
}




